
import {
    logoutUser
} from "../../redux/actions/authActions";
import val from "../../getThemeDetails"
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
// import sessionStorage from "redux-persist/es/storage/session";
const SOLogout = (dispatch, authToken, partnerId) => {

    NotificationPopups("error", "Failed", 'Session Out');
    // console.log("AUTTTHHHToken",authToken)
    //localStorage.removeItem('theme')
      dispatch(logoutUser({
          authToken: sessionStorage.getItem("authToken") || "",
          authentication: {
              partnerId: val.walletOwnerId
          }
      }));
}

export default SOLogout